export const notificationSocketEvents = [
  'requisicao-atualizada',
  'aprovacao-pendente',
  'proposta-recebida',
  'compra-finalizada',
  'fornecedor-notificacao',
  'comunicado-publicado'
] as const;

export type NotificationSocketEvent = typeof notificationSocketEvents[number];

export interface NotificationDto {
  id: string;
  tenantId?: string | null;
  usuarioId?: string | null;
  fornecedorId?: string | null;
  actorTipo?: string | null;
  tipo: string;
  categoria?: string;
  titulo?: string;
  mensagem: string;
  entidade?: string | null;
  entidadeId?: string | null;
  urlDestino?: string | null;
  prioridade?: string;
  lida: boolean;
  dataLeitura?: string | null;
  createdAt: string;
}

